<h2 mat-dialog-title>Manage User Data</h2>
<mat-dialog-content>

  <form [formGroup]="form">
    <app-user-data formControlName="userData" [performanceTypes]="data.performanceTypes"></app-user-data>
  </form>

</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()">Cancel</button>
  <button matButton (click)="save()">Save</button>
</mat-dialog-actions>
